<template>
  <div>
    <v-dialog v-model="dialog" persistent :width="!isMail ? 900 : 900">
      <v-card>
        <v-toolbar color="white" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-car</v-icon>
            {{ $i18n.t(label) }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <z-template-select
                v-model="print.type"
                :kind="5"
              ></z-template-select>
            </v-col>
            <v-col cols="12" md="12" sm="12">
              <v-select
                v-model="print.headerText"
                :label="$i18n.t('Header')"
                :items="['','Original', 'Duplicate', 'Triplicate']"
                item-text="name"
                item-value="value"
              ></v-select>
            </v-col>
            <v-col cols="3" md="3" sm="3">
              <v-checkbox
                v-model="print.isLandscape"
                :label="$i18n.t('Landscape Print')"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" md="3" sm="3">
              <v-checkbox
                v-model="print.hideHeader"
                :label="$i18n.t('On Letterhead')"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" md="3" sm="3">
              <v-checkbox
                v-model="print.doNotSort"
                :label="$i18n.t('Do Not Sort')"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" md="3" sm="3">
              <v-checkbox
                v-model="print.hideRCM"
                :label="$i18n.t('Hide RCM Applicable')"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" md="3" sm="3">
              <v-checkbox
                v-model="print.showTaxes"
                :label="$i18n.t('Show Taxes')"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" md="3" sm="3">
              <v-checkbox
                v-model="print.showAdditional"
                :label="$i18n.t('Show Additional')"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" md="3" sm="3">
              <v-checkbox
                v-model="print.asBillNo"
                :label="$i18n.t('As Bill')"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="isMail">
            <v-col cols="12" md="6">
              <v-select
                :items="emailList"
                v-model="print.selectedMail"
                :label="$i18n.t('Email')"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="print.otherEmails"
                :label="$i18n.t('Other emails comma separated')"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox
                v-model="print.sendPaymentLink"
                :label="$i18n.t('Send Payment Link')"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="sticky-bottom">
          <v-spacer></v-spacer>
          <v-btn
            v-if="!isMail"
            @click="finalPrint"
            color="teal"
            :loading="loadingPrint"
          >
            <v-icon small>mdi-printer</v-icon>
            {{ $i18n.t("Print") }}
          </v-btn>
          <v-btn
            v-if="isMail"
            @click="sendInvoiceEmail"
            color="teal"
            :loading="loadingPrint"
          >
            <v-icon small>mdi-send-outline</v-icon>
            {{ $i18n.t("Send") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { doPost, doGet, doPostWithDownload } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "InvoiceDownload",
  props: {
    payload: {
      default: {},
    },
    showDialog: {
      default: false,
    },
    isMail: {
      default: false,
    },
    invoice: {
      default: null,
    },
  },
})
export default class InvoiceDownload extends (Vue, Themeable) {
  url = "api/invoiceconfig/invoice/formats";
  on = null;
  dialog = false;
  allFormats = [];
  print = { type: null, isLandscape: true, hideHeader: true };
  invoiceFormatList = [];
  emailList = [];
  loadingPrint = null;

  get loading() {
    return common.loading;
  }

  get label() {
    if (!this.isMail) {
      return "Print Invoice";
    } else {
      return "Send Invoice by Email";
    }
  }

  showFormat(_type) {
    if (!this.invoiceFormatList || this.invoiceFormatList.length < 1) {
      return true;
    }
    for (let i = 0; i < this.invoiceFormatList.length; i++) {
      if (this.invoiceFormatList[i].type == _type) {
        return true;
      }
    }
    return false;
  }

  closeDialog() {
    this.dialog = false;
    this.$emit("closeDialog", false);
  }

  async fetchFormats() {
    const data = {};
    data.client_id = this.payload.client_id;
    data.clientEntity_id = this.payload.clientEntity_id;
    data.vendor_id = this.payload.vendor_id;
    data.vendorEntity_id = this.payload.vendorEntity_id;
    this.invoiceFormatList = await doPost(
      "/api/invoiceconfig/invoice/formats",
      data
    );
    this.allFormats = [];
  }

  changePrintBy(_print, valueOf) {
    if (this.invoiceFormatList && this.invoiceFormatList.length > 0) {
      for (let i = 0; i < this.invoiceFormatList.length; i++) {
        if (this.invoiceFormatList[i].type == valueOf) {
          this.print.withMap = this.invoiceFormatList[i].withMap;
          this.print.plannedAddr = this.invoiceFormatList[i].plannedAddress;
        }
      }
    }
  }

  async finalPrint() {
    let pURL = "/api/invoice/bulk/invoices/print2?";

    try {
      this.loadingPrint = true;
      if (this.payload.invoice_ids) {
        this.print.invoice_ids = this.payload.invoice_ids;
      }

      const _printData = this.print;
      if (_printData.type && _printData.type.length > 20) {
        _printData.printType = 14;
        pURL = pURL + "&template_id=" + _printData.type;
      }
      if (_printData.isLandscape) {
        pURL += "&isLandscape=true";
      }

      await doPostWithDownload(pURL, this.print);
      this.loadingPrint = null;
    } catch (e) {
      console.log(e);
      this.loadingPrint = null;
    }
    this.closeDialog();
  }

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.dialog = val;
  }

  async sendInvoiceEmail() {
    if (!this.print.otherEmails && !this.print.selectedMail) {
      common.setError("Please select/enter email(s) to send invoice");
      return;
    }
    let emails = "";
    if (this.print.otherEmails) {
      emails = this.print.otherEmails + ",";
    }
    if (this.print.selectedMail) {
      emails = emails + this.print.selectedMail;
    }
    let type = this.print.type;
    if (this.print.type == 0 && this.print.withMap) {
      type = 1;
    }
    let p_Url =
      "/api/invoice/" +
      this.invoice._id +
      "/print?printType=" +
      type +
      "&email=" +
      emails +
      "&withPmntLnk=" +
      this.print.sendPaymentLink;
    if (this.print.withMap) {
      p_Url += "&withMap=true";
    }
    if (this.print.isLandscape) {
      p_Url += "&isLandscape=true";
    }
    if (this.print.plannedAddr) {
      p_Url += "&plannedAddr=true";
    }
    p_Url += "&";
    try {
      this.loadingPrint = null;
      common.setLoading(true);
      await doGet(p_Url);
      common.setLoading(false);
      common.showMessage("Invoice sent through email successfully");
      this.closeDialog();
      this.loadingPrint = null;
    } catch (e) {
      this.loadingPrint = null;
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  @Watch("dialog")
  async onDialogChange(newVal) {
    if (newVal) {
      try {
        await this.fetchFormats();
        this.fetchEmailList();
      } catch (e) {
        common.setError(e.message);
      }
    }
  }

  fetchEmailList() {
    const emails = [];
    let distinctEmails = [];
    if (!this.invoice) return;
    if (
      this.invoice.clientEntity &&
      this.invoice.clientEntity.corporate &&
      this.invoice.clientEntity.corporate.email
    ) {
      emails.push(this.invoice.clientEntity.corporate.email);
    }
    if (this.invoice.tripInvoices) {
      for (let i = 0; i < this.invoice.tripInvoices.length; i++) {
        if (this.invoice.tripInvoices[i].passengers) {
          for (
            let j = 0;
            j < this.invoice.tripInvoices[i].passengers.length;
            j++
          ) {
            if (this.invoice.tripInvoices[i].passengers[j].email) {
              emails.push(this.invoice.tripInvoices[i].passengers[j].email);
            }
          }
        }
        if (
          this.invoice.tripInvoices[i].passenger &&
          this.invoice.tripInvoices[i].passenger.email
        ) {
          emails.push(this.invoice.tripInvoices[i].passenger.email);
        }
        if (
          this.invoice.tripInvoices[i].bookedBy &&
          this.invoice.tripInvoices[i].bookedBy.email
        ) {
          emails.push(this.invoice.tripInvoices[i].bookedBy.email);
        }
      }
    }
    if (emails && emails.length > 0) {
      distinctEmails = emails.filter((value, index, self) => {
        return self.indexOf(value) === index;
      });
    }
    this.emailList = distinctEmails;
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
.v-dialog > .v-card > .v-card__text {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-card .v-card__actions {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-dialog .v-card .v-card__title {
  padding-top: 10px;
}
</style>
